module.exports = __webpack_public_path__ + "static/media/successful.45deacfc.svg";